<div *ngIf="showToast" class="toast-container">
  <div [ngClass]="['toast-message', toastType === 'success' ? 'toast-success' : 'toast-error']">
    <div class="toast-content">
      <div class="toast-text">
        <div class="toast-title" *ngIf="toastTitle">{{ toastTitle }}</div>
        <div class="toast-message-text">{{ toastMessageText }}</div>
      </div>
      <span class="material-symbols-outlined f-24 cursor-pointer" tabindex="0" (click)="closeToast()"
        (keypress)="closeToast()" title="Close">close</span>
    </div>
  </div>
</div>

<div *ngIf="showPaymentForm" class="fee-payment-container">
  <div class="" *ngIf="paymentFail">
    <div class="persistent-error-message error-message">
      <span>
        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <line x1="6" y1="6" x2="18" y2="18" stroke="#d32f2f" stroke-width="3" stroke-linecap="round" />
          <line x1="18" y1="6" x2="6" y2="18" stroke="#d32f2f" stroke-width="3" stroke-linecap="round" />
        </svg>
      </span>
      <span>
        {{errorMessages['M0163'] || 'An unexpected error occurred. Please try again.'}}
      </span>
    </div>
  </div>
  <div class="container-body" [ngClass]="paymentFail?'mt-6':''">
    <div class=" payment-summary-card">
      <p class="section-title">Fee Summary</p>
      <hr />
      <div class="fee-items">
        <!-- Normal payment fee rows -->
        <ng-container *ngIf="!isAdditionalPayment">
          <div *ngIf="addEndrose !== 'Add Endorsement'" class="fee-item mb-3">
            <span class="fee-label">Application Fee  <span class="info-icon-wrapper" tabindex="0" (click)="showAppFeeTooltip = !showAppFeeTooltip"
                (mouseenter)="showAppFeeTooltip = true" (mouseleave)="showAppFeeTooltip = false"
                (keydown.enter)="showAppFeeTooltip = !showAppFeeTooltip">
                <span class="material-symbols-outlined info-icon">info</span>
                <span class="info-tooltip" *ngIf="showAppFeeTooltip">{{ genericMessage['G0020'] }}</span>
              </span>
          <span class="requiredfield text-danger">*</span></span>
            <span class="fee-colon font-weight-bold">:</span>
            <span class="fee-amount">${{ applicationFee | number:'1.0-0' }}</span>
          </div>
          <div class="fee-item mb-3" *ngIf="LiceanceEndrosementFee !== null && LiceanceEndrosementFee !== '' && +LiceanceEndrosementFee !== 0">
            <span class="fee-label">Additional Endorsement</span>
            <span class="fee-colon font-weight-bold">:</span>
            <span class="fee-amount" *ngIf="endorsementUnitFee > 0 && endorsementCount > 0">${{ endorsementUnitFee | number:'1.0-0' }} × {{ endorsementCount }}</span>
            <span class="fee-amount" *ngIf="!(endorsementUnitFee > 0 && endorsementCount > 0)">${{ LiceanceEndrosementFee | number:'1.0-0' }}</span>
          </div>
          <div class="fee-item exemption mb-3" *ngIf="VeteranExemption !== null && VeteranExemption !== ''  && +VeteranExemption !== 0">
            <span class="fee-label">Military Exemption</span>
            <span class="fee-colon font-weight-bold">:</span>
            <span class="fee-amount discount">-${{ VeteranExemption | number:'1.0-0' }}</span>
          </div>
          <div class="fee-item mb-3" *ngIf="extensionFee !== null && extensionFee !== ''">
            <span class="fee-label">Extension Fee</span>
            <span class="fee-colon font-weight-bold">:</span>
            <span class="fee-amount">${{ extensionFee | number:'1.0-0' }}</span>
          </div>
        </ng-container>

        <!-- Additional payment fee rows (new endorsements / veteran payback) -->
        <ng-container *ngIf="isAdditionalPayment">
          <div class="fee-item mb-3" *ngIf="additionalEndorsementFee > 0">
            <span class="fee-label">Additional Endorsement</span>
            <span class="fee-colon font-weight-bold">:</span>
            <span class="fee-amount">${{ additionalEndorsementUnitFee | number:'1.0-0' }} × {{ additionalEndorsementCount }}</span>
          </div>
          <div class="fee-item mb-3" *ngIf="veteranAdjustmentFee > 0">
            <span class="fee-label">Military Exemption Adjustment</span>
            <span class="fee-colon font-weight-bold">:</span>
            <span class="fee-amount">${{ veteranAdjustmentFee | number:'1.0-0' }}</span>
          </div>
        </ng-container>
        <div class="fee-item exemption mb-3" *ngIf="appliedCredit > 0">
          <span class="fee-label">Credit Applied</span>
          <span class="fee-colon font-weight-bold">:</span>
          <span class="fee-amount discount">-${{ appliedCredit | number:'1.0-0' }}</span>
        </div>

        <div class="total-section">
          <div class="total-fees rightmargin">
            <span class="total-label">Total</span>
            <span class="fee-colon marging font-weight-bold">:</span>
            <span class="total-amount">${{ appliedCredit > 0 ? ((grossApplicationTotalFee - appliedCredit) | number:'1.0-0') : (applicationTotalFee | number:'1.0-0') }}</span>
          </div>
        </div>
      </div>

      <div class="fee-modal">
        <p class="mt-1 ">This is your final fee summary. Fees are non-refundable per NAC 391.045. Payment does not guarantee
          approval.
          Please review all
          amounts before proceeding. Military exemptions have been applied if eligible.</p>
        </div>
      </div>
      <div class="payment-form-right">
        <form class="payment-form-container" id="form_paymentform_main" autocomplete="off" (ngSubmit)="onSubmit()"
          [formGroup]="paymentForm">
          <p class="section-title font-weight-bold" id="label_paymentform_paymentdetails">
            Payment Details
          </p>
           <div class="accepted-cards-row">
            <img src="assets/images/visa.svg" alt="Visa" class="accepted-card-img" />
            <img src="assets/images/Mastercard.svg" alt="Mastercard" class="accepted-card-img" />
            <img src="assets/images/Discover.svg" alt="Discover" class="accepted-card-img" />
            <img src="assets/images/American Express.svg" alt="American Express" class="accepted-card-img" />
          </div>
          <div class="input-group mb-2" id="div_paymentform_cardname">
            <label id="label_paymentform_cardname" for="cardName">Name on Card<span class="required">*</span></label>
            <input id="input_paymentform_cardname" class="mb-0" type="text" maxlength="26" formControlName="cardName"
              (input)="onCardNameInput(); paymentResetService.resetInactivityTimer()" (blur)="onCardNameBlur()" placeholder="Name on Card">
            <div id="error_paymentform_cardname"
              *ngIf="paymentForm.get('cardName')?.touched && paymentForm.get('cardName')?.invalid"
              class="text-red mb-1 mt-0">
              <span *ngIf="paymentForm.get('cardName')?.errors?.['required']">Please enter a Name on card.</span>
              <span
                *ngIf="!paymentForm.get('cardName')?.errors?.['required'] && paymentForm.get('cardName')?.invalid">Only
                letters, spaces, hyphens, apostrophes, and periods are allowed. No numbers or special symbols.</span>
            </div>
          </div>

          <div class="input-group mb-2" id="div_paymentform_cardnumber">
            <label id="label_paymentform_cardnumber" for="cardNumber">Card Number<span class="required">*</span></label>
            <input id="input_paymentform_cardnumber" class="mb-0" type="text" maxlength="23" formControlName="number"
              (input)="onCardNumberInput(); paymentResetService.resetInactivityTimer()" [placeholder]="placeholderMessage['P0073']" (blur)="onCardNumberBlur()"
              (focus)="showFullCardNumberOnFocus($event)" appCardNumberMask>
            <img *ngIf="cardTypeIcon" [src]="cardTypeIcon" class="card-type-icon card-type" [alt]="cardType || 'Card'">
            <div id="error_paymentform_cardnumber"
              *ngIf="paymentForm.get('number')?.touched && paymentForm.get('number')?.invalid"
              class="text-red mb-1 mt-0">
              <span *ngIf="paymentForm.get('number')?.errors?.['required']">{{ errorMessages['M0105'] }}</span>
              <span *ngIf="paymentForm.get('number')?.errors?.['invalidCardNumber']">{{ errorMessages['M0109'] }}</span>
              <span *ngIf="paymentForm.get('number')?.errors?.['invalidCardLength']">{{ errorMessages['M0109'] }}</span>
              <span *ngIf="paymentForm.get('number')?.errors?.['notAcceptedCardType']">{{ errorMessages['M0164']
                }}</span>
              <span *ngIf="paymentForm.get('number')?.errors?.['testCard']">Test card numbers are not allowed.</span>
            </div>
          </div>

          <div class="payment-form-row" id="row_paymentform_expdate_securityCode">
            <div class="input-group mb-2" id="div_paymentform_expdate">
              <label id="label_paymentform_expdate" for="expDate">Expiration Date (MM/YY)<span
                  class="required">*</span></label>
              <input id="input_paymentform_expdate" class="mb-0" type="text" maxlength="7" formControlName="expDate"
                [placeholder]="placeholderMessage['P0074']" (input)="onExpDateInput(); paymentResetService.resetInactivityTimer()" (blur)="onExpDateBlur()"
                (paste)="onExpDatePaste($event)">
              <div id="error_paymentform_expdate"
                *ngIf="paymentForm.get('expDate')?.touched && paymentForm.get('expDate')?.invalid"
                class="text-red mb-1 mt-0">
                <ng-container *ngIf="paymentForm.get('expDate')?.touched && paymentForm.get('expDate')?.invalid">
                  <span *ngIf="paymentForm.get('expDate')?.errors?.['required']">{{ errorMessages['M0106'] }}</span>
                  <span
                    *ngIf="!paymentForm.get('expDate')?.errors?.['required'] && paymentForm.get('expDate')?.errors?.['invalidExpDate']">{{
                    errorMessages['M0110']}}</span>
                       <span
                    *ngIf="!paymentForm.get('expDate')?.errors?.['required'] && !paymentForm.get('expDate')?.errors?.['tooFarFuture'] && paymentForm.get('expDate')?.errors?.['tooFarFuture']">{{
                    errorMessages['M0171']}}</span>
                  <span
                    *ngIf="!paymentForm.get('expDate')?.errors?.['required'] && !paymentForm.get('expDate')?.errors?.['invalidExpDate'] && paymentForm.get('expDate')?.errors?.['invalidExpMonth']">{{
                    errorMessages['M0172']  }}</span>
                    <span
                    *ngIf="!paymentForm.get('expDate')?.errors?.['required'] && !paymentForm.get('expDate')?.errors?.['invalidExpDate'] && !paymentForm.get('expDate')?.errors?.['invalidExpMonth'] && paymentForm.get('expDate')?.errors?.['tooFarFuture']">{{ errorMessages['M0171'] }}</span>
                  <span
                    *ngIf="!paymentForm.get('expDate')?.errors?.['required'] && !paymentForm.get('expDate')?.errors?.['invalidExpDate'] && !paymentForm.get('expDate')?.errors?.['invalidExpMonth'] && paymentForm.get('expDate')?.errors?.['expired']">Card
                    is expired.</span>
                </ng-container>
              </div>
            </div>
            <div class="input-group mb-2" id="div_paymentform_securityCode">
              <label id="label_paymentform_securityCode" for="securityCode">Security Code<span
                  class="required">*</span></label>
              <input id="input_paymentform_securityCode" class="mb-0" [type]="showsecurityCode ? 'text' : 'password'"
                maxlength="4" formControlName="securityCode" [placeholder]="placeholderMessage['P0075']"
                (input)="onsecurityCodeInput(); paymentResetService.resetInactivityTimer()">
              <button id="button_paymentform_securityCode_toggle" type="button" class="securityCode-toggle mb-0"
                [disabled]="isCreditOnly" (click)="showsecurityCode = !showsecurityCode" tabindex="-1">
                <span *ngIf="showsecurityCode">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1 12C2.73 7.61 7.11 4.5 12 4.5C16.89 4.5 21.27 7.61 23 12C21.27 16.39 16.89 19.5 12 19.5C7.11 19.5 2.73 16.39 1 12Z"
                      stroke="#888" stroke-width="2" fill="none" />
                    <circle cx="12" cy="12" r="3.5" stroke="#888" stroke-width="2" fill="none" />
                  </svg>
                </span>
                <span *ngIf="!showsecurityCode">
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M1 12C2.73 7.61 7.11 4.5 12 4.5C16.89 4.5 21.27 7.61 23 12C21.27 16.39 16.89 19.5 12 19.5C7.11 19.5 2.73 16.39 1 12Z"
                      stroke="#888" stroke-width="2" fill="none" />
                    <circle cx="12" cy="12" r="3.5" stroke="#888" stroke-width="2" fill="none" />
                    <line x1="4" y1="20" x2="20" y2="4" stroke="#888" stroke-width="2" />
                  </svg>
                </span>
              </button>
              <div id="error_paymentform_securityCode"
                *ngIf="paymentForm.get('securityCode')?.touched && paymentForm.get('securityCode')?.invalid"
                class="text-red mb-1 mt-0">
                <span *ngIf="paymentForm.get('securityCode')?.errors?.['required']">{{ errorMessages['M0107'] }}</span>
                <span *ngIf="paymentForm.get('securityCode')?.errors?.['invalidsecurityCode']">{{ errorMessages['M0111']
                  }}</span>
              </div>
            </div>
          </div>

          <div class="input-group mb-2" id="div_paymentform_zip">
            <label id="label_paymentform_zip" for="zip" z>Billing Zip Code<span class="required">*</span></label>
            <input id="input_paymentform_zip" class="mb-0" type="text" maxlength="10" formControlName="zip"
              placeholder="Billing Zip Code" (input)="onZipInput(); paymentResetService.resetInactivityTimer()" (paste)="onZipPaste($event)">
            <div id="error_paymentform_zip" *ngIf="paymentForm.get('zip')?.touched && paymentForm.get('zip')?.invalid"
  class="text-red mb-3 mt-0">
  <span *ngIf="paymentForm.get('zip')?.errors?.['required']">{{ errorMessages['M0022'] }}</span>
  <span *ngIf="!paymentForm.get('zip')?.errors?.['required'] && (paymentForm.get('zip')?.errors?.['minlength'] || paymentForm.get('zip')?.errors?.['maxlength'] || paymentForm.get('zip')?.errors?.['pattern'])">
    {{ errorMessages['M0023'] }}
  </span>
</div>
          </div>

          <div id="div_paymentform_buttons" class="payment-buttons-row">
            <button id="button_paymentform_reset" type="button" class="btn btn-outline col"
              (click)="onReset()">Reset</button>
            <button id="button_paymentform_submit" type="submit" class="btn btn-primary btn-radius col"
              [disabled]="paymentForm.invalid">{{ submitButtonLabel }}</button>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div *ngIf="showPaymentHistory" class="payment-success-table-wrapper payments-success-table-wrapper">
    <div class="d-flex justify-content-between pl-1 pr-1 mb-3 heading-row">
        <p class="page-heading page-heading--no-margin fee-title">Payment History</p>
      <!-- <div class="queues-export-btn-group queues-export-btn-group--no-margin">
        <button mat-icon-button class="icon-btn feeicon-btn" id="queues_button_export" pTooltip="Export" tooltipPosition="bottom" (click)="downloadExcel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
            <path
              d="M12 16.5C11.7239 16.5 11.5 16.2761 11.5 16V8C11.5 7.72386 11.7239 7.5 12 7.5C12.2761 7.5 12.5 7.72386 12.5 8V16C12.5 16.2761 12.2761 16.5 12 16.5Z"
              fill="#444" />
            <path
              d="M8.46967 12.9697C8.17678 12.6768 8.17678 12.2019 8.46967 11.909C8.76256 11.6161 9.23744 11.6161 9.53033 11.909L12 14.3787L14.4697 11.909C14.7626 11.6161 15.2374 11.6161 15.5303 11.909C15.8232 12.2019 15.8232 12.6768 15.5303 12.9697L12.5303 15.9697C12.2374 16.2626 11.7626 16.2626 11.4697 15.9697L8.46967 12.9697Z"
              fill="#444" />
            <rect x="5" y="18" width="14" height="2" rx="1" fill="#444" />
          </svg>
        </button>
      </div>  -->
    </div>
    <dx-data-grid [dataSource]="paymentTableData" [showBorders]="true" [columnAutoWidth]="true"
      [rowAlternationEnabled]="true" [filterRow]="{ visible: true }" [headerFilter]="{ visible: true }"
      [paging]="{ enabled: false }" [noDataText]="'No payment data'">
      <dxi-column dataField="transactionId" caption="Transaction ID" alignment="center"></dxi-column>
      <!-- <dxi-column dataField="cardName" caption="Name on Card" alignment="center"></dxi-column>
    <dxi-column dataField="cardNumber" caption="Card Number (Last 4 digits)" cellTemplate="cardNumberCell"
      alignment="center"></dxi-column>
    <div *dxTemplate="let data of 'cardNumberCell'">
      <span>{{ formatMaskedCardNumber(data.data.cardNumber) }}</span>
    </div> -->
       <dxi-column dataField="amount" caption="Amount" [calculateCellValue]="formatAmount"
        alignment="center" cellTemplate="amountCell"></dxi-column>
      <div *dxTemplate="let data of 'amountCell'">
        <span>${{ data.value }}</span>
      </div>
      <dxi-column dataField="date" caption="Date" alignment="center"></dxi-column>
      <dxi-column dataField="status" caption="Status" cellTemplate="statusCell" alignment="center"></dxi-column>
      <dxi-column caption="Action" cellTemplate="actionCell" alignment="center" [width]="100" ></dxi-column>

      <div *dxTemplate="let data of 'statusCell'">
        <span [ngClass]="{'status-badge': true, 'paid': data.data.status === 'Paid'}">
          <span class="dot-s"></span> {{data.data.status}}
        </span>
      </div>
       <div *dxTemplate="let data of 'actionCell'">
      <div class="action-cell-buttons" *ngIf="data.data.status?.toLowerCase() !== 'Declined'">
        <span class="action-btn-wrapper" title="View Receipt">
          <button class="download-btn download-btn--icon" (click)="viewPayment(data.data)">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" fill="white" stroke="#E2E3E6" />
              <path
                d="M8.5 25.8791V8.11763C8.5 8.01379 8.54358 7.94421 8.63075 7.90887C8.71792 7.87371 8.8 7.88821 8.877 7.95237L9.59225 8.58112C9.67942 8.65546 9.77692 8.69263 9.88475 8.69263C9.99242 8.69263 10.0898 8.65546 10.177 8.58112L11.0155 7.87737C11.1027 7.80287 11.2001 7.76562 11.3077 7.76562C11.4154 7.76562 11.5128 7.80287 11.6 7.87737L12.4385 8.58112C12.5257 8.65546 12.6231 8.69263 12.7308 8.69263C12.8384 8.69263 12.9358 8.65546 13.023 8.58112L13.8615 7.87737C13.9487 7.80287 14.0461 7.76562 14.1537 7.76562C14.2616 7.76562 14.3591 7.80287 14.4463 7.87737L15.2848 8.58112C15.3719 8.65546 15.4693 8.69263 15.577 8.69263C15.6847 8.69263 15.7821 8.65546 15.8692 8.58112L16.7078 7.87737C16.7949 7.80287 16.8923 7.76562 17 7.76562C17.1077 7.76562 17.2051 7.80287 17.2923 7.87737L18.1307 8.58112C18.2179 8.65546 18.3153 8.69263 18.423 8.69263C18.5307 8.69263 18.6281 8.65546 18.7153 8.58112L19.5538 7.87737C19.6409 7.80287 19.7384 7.76562 19.8462 7.76562C19.9539 7.76562 20.0513 7.80287 20.1385 7.87737L20.977 8.58112C21.0642 8.65546 21.1616 8.69263 21.2693 8.69263C21.3769 8.69263 21.4743 8.65546 21.5615 8.58112L22.4 7.87737C22.4872 7.80287 22.5846 7.76562 22.6923 7.76562C22.7999 7.76562 22.8973 7.80287 22.9845 7.87737L23.823 8.58112C23.9102 8.65546 24.0076 8.69263 24.1152 8.69263C24.2231 8.69263 24.3206 8.65546 24.4078 8.58112L25.123 7.95237C25.2 7.88821 25.2821 7.87371 25.3693 7.90887C25.4564 7.94421 25.5 8.01379 25.5 8.11763V25.8791C25.5 25.983 25.4564 26.0525 25.3693 26.0879C25.2821 26.123 25.2 26.1085 25.123 26.0444L24.4078 25.4156C24.3206 25.3413 24.2231 25.3041 24.1152 25.3041C24.0076 25.3041 23.9102 25.3413 23.823 25.4156L22.9845 26.1194C22.8973 26.1939 22.7999 26.2311 22.6923 26.2311C22.5846 26.2311 22.4872 26.1939 22.4 26.1194L21.5615 25.4156C21.4743 25.3413 21.3769 25.3041 21.2693 25.3041C21.1616 25.3041 21.0642 25.3413 20.977 25.4156L20.1385 26.1194C20.0513 26.1939 19.9539 26.2311 19.8462 26.2311C19.7384 26.2311 19.6409 26.1939 19.5538 26.1194L18.7153 25.4156C18.6281 25.3413 18.5307 25.3041 18.423 25.3041C18.3153 25.3041 18.2179 25.3413 18.1307 25.4156L17.2923 26.1194C17.2051 26.1939 17.1077 26.2311 17 26.2311C16.8923 26.2311 16.7949 26.1939 16.7078 26.1194L15.8692 25.4156C15.7821 25.3413 15.6847 25.3041 15.577 25.3041C15.4693 25.3041 15.3719 25.3413 15.2848 25.4156L14.4463 26.1194C14.3591 26.1939 14.2616 26.2311 14.1537 26.2311C14.0461 26.2311 13.9487 26.1939 13.8615 26.1194L13.023 25.4156C12.9358 25.3413 12.8384 25.3041 12.7308 25.3041C12.6231 25.3041 12.5257 25.3413 12.4385 25.4156L11.6 26.1194C11.5128 26.1939 11.4154 26.2311 11.3077 26.2311C11.2001 26.2311 11.1027 26.1939 11.0155 26.1194L10.177 25.4156C10.0898 25.3413 9.99242 25.3041 9.88475 25.3041C9.77692 25.3041 9.67942 25.3413 9.59225 25.4156L8.877 26.0444C8.8 26.1085 8.71792 26.123 8.63075 26.0879C8.54358 26.0525 8.5 25.983 8.5 25.8791ZM12 21.4406H22C22.2128 21.4406 22.391 21.3689 22.5345 21.2254C22.6782 21.0817 22.75 20.9035 22.75 20.6906C22.75 20.4778 22.6782 20.2996 22.5345 20.1561C22.391 20.0125 22.2128 19.9406 22 19.9406H12C11.7872 19.9406 11.609 20.0125 11.4655 20.1561C11.3218 20.2996 11.25 20.4778 11.25 20.6906C11.25 20.9035 11.3218 21.0817 11.4655 21.2254C11.609 21.3689 11.7872 21.4406 12 21.4406ZM12 17.7484H22C22.2128 17.7484 22.391 17.6765 22.5345 17.5329C22.6782 17.3894 22.75 17.2112 22.75 16.9984C22.75 16.7855 22.6782 16.6074 22.5345 16.4639C22.391 16.3202 22.2128 16.2484 22 16.2484H12C11.7872 16.2484 11.609 16.3202 11.4655 16.4639C11.3218 16.6074 11.25 16.7855 11.25 16.9984C11.25 17.2112 11.3218 17.3894 11.4655 17.5329C11.609 17.6765 11.7872 17.7484 12 17.7484ZM12 14.0561H22C22.2128 14.0561 22.391 13.9843 22.5345 13.8406C22.6782 13.6971 22.75 13.519 22.75 13.3061C22.75 13.0933 22.6782 12.915 22.5345 12.7714C22.391 12.6279 22.2128 12.5561 22 12.5561H12C11.7872 12.5561 11.609 12.6279 11.4655 12.7714C11.3218 12.915 11.25 13.0933 11.25 13.3061C11.25 13.519 11.3218 13.6971 11.4655 13.8406C11.609 13.9843 11.7872 14.0561 12 14.0561ZM10 24.0984H24V9.89838H10V24.0984Z"
                fill="#444444" />
            </svg>
          </button>
        </span>
        <span class="action-btn-wrapper" pTooltip="Download Receipt" tooltipPosition="bottom">
          <button class="download-btn download-btn--icon" (click)="downloadPayment(data.data)">
            <svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="0.5" y="0.5" width="33" height="33" rx="4.5" fill="white" stroke="#E2E3E6" />
              <path d="M17 10V20M17 20L13 16M17 20L21 16" stroke="#444444" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M11 22H23" stroke="#444444" stroke-width="1.8" stroke-linecap="round" />
            </svg>
          </button>
        </span>
      </div>
    </div>
    </dx-data-grid>
  </div>

  <!-- Navigation Buttons - Always visible -->
  <div class="navigation-buttons-container" *ngIf="!hidePreviousNextButtons">
    <button class="btn btn-outline-secondary float-left" (click)="moveToPrevious()">
      <span class="fas fa-arrow-left"></span> Previous
    </button>
    <button class="btn btn-primary float-right" [disabled]="!hasAuthorizedTransaction " (click)="moveToNext()">Next
      <span class="fas fa-arrow-right"></span></button>
  </div>

  <!--Modal -->
  <div class="modal-overlay" *ngIf="showModal" (click)="closeModal()" (keydown.escape)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
      <button class="modal-close" (click)="closeModal()">
        <i class="fas fa-times"></i>
      </button>
      <div class="modal-body">
        <div class="success-icon">
          <img src="../../../assets/images/cardy-ai/tick logo.png" alt="Success" width="60" height="60" />
        </div>
        <h2 class="modal-title">Payment Competed Successfully</h2>
        <p class="modal-subtitle">You can now download your invoice</p>
      </div>
    </div>
  </div>

  <!-- Payment Processing Modal -->
  <div class="modal-overlay processing-modal-overlay" *ngIf="showPaymentProcessingModal">
    <div class="modal-content processing-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-body">
        <div class="processing-spinner">
          <div class="spinner"></div>
        </div>
        <h2 class="modal-title">Processing Payment</h2>
        <p class="processing-message">Processing your payment. Please do not refresh or close this page.</p>
        <p class="processing-message">You will be redirected to the Dashboard upon successful payment.</p>
      </div>
    </div>
  </div>